import React from "react";
import Home from "./Home";
import BondTicker from "./BondTicker";
import BondVsHouse from "./BondVsHouse";
import BondLab from "./BondLab";
import DownloadCta from "./DownloadCta";

const MainSection = () => {
  return (
    <main>
      <Home />
      <BondTicker />
      <BondVsHouse />
      <BondLab />
      <DownloadCta />
    </main>
  );
};

export default MainSection;
